// ProtectedRoute.jsx
import React, { useEffect, useContext } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { UserContext } from "context";

const ProtectedRoute = ({ children, hasAccess = () => true }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const user = useContext(UserContext);

  useEffect(() => {
    if (!authState) return;
    if (!authState.isAuthenticated) {
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  if (!authState?.isAuthenticated) {
    return <div>Please wait while we sign you in</div>;
  }

  if (authState?.isAuthenticated && !user) {
    return <div>Fetching user details</div>;
  }

  // Support both a predicate and a boolean prop
  const allowed =
    typeof hasAccess === "function" ? hasAccess(user) : Boolean(hasAccess);

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node,
  // allow a function (user => boolean) OR a plain boolean
  hasAccess: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

export default ProtectedRoute;
